import { useEffect, useState } from 'react';
import { api, ApiError } from '../lib/api';
import { Notice } from './ui';

type Status = { apple: boolean; google: boolean; samsung: boolean };

function platform(): 'ios' | 'android' | 'other' {
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && 'ontouchend' in document)) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  return 'other';
}

/** Wallet buttons for the card page: Apple Wallet on iOS, Google Wallet on Android (covers Samsung), plus add-to-home-screen. */
export function WalletButtons({ token }: { token: string }) {
  const [st, setSt] = useState<Status | null>(null);
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);
  const pf = platform();
  useEffect(() => { api.get<Status>('/api/public/wallet/status').then(setSt).catch(() => setSt({ apple: false, google: false, samsung: false })); }, []);
  async function google() {
    setBusy(true);
    try { const r = await api.get<{ url: string }>(`/api/public/wallet/${token}/google`); location.href = r.url; }
    catch (e) { setMsg(e instanceof ApiError ? (e.message_ar ?? e.message) : 'تعذر فتح Google Wallet.'); }
    setBusy(false);
  }
  if (!st) return null;
  const configured = st.apple || st.google;
  return (
    <section className="card p-5 grid gap-3">
      <h3>احفظ بطاقتك في جوالك</h3>
      <div className="flex flex-wrap gap-2">
        {(pf === 'ios' || pf === 'other') && (
          st.apple
            ? <a className="btn btn-primary" href={`/api/public/wallet/${token}/apple.pkpass`}>أضفها إلى Apple Wallet</a>
            : <button className="btn btn-ghost" disabled>Apple Wallet قيد الإعداد</button>
        )}
        {(pf === 'android' || pf === 'other') && (
          st.google
            ? <button className="btn btn-primary" disabled={busy} onClick={google}>أضفها إلى Google Wallet</button>
            : <button className="btn btn-ghost" disabled>Google Wallet قيد الإعداد</button>
        )}
      </div>
      {msg && <Notice kind="warn">{msg}</Notice>}
      <p className="muted text-xs">
        {pf === 'android' ? 'على أجهزة سامسونج تعمل Google Wallet، وتكامل Samsung Wallet المباشر يحتاج شراكة مع سامسونج.' : ''}
        {!configured ? ' حتى يكتمل الإعداد: أضف هذه الصفحة إلى الشاشة الرئيسية من قائمة المشاركة في المتصفح، فتفتح كبطاقة.' : ''}
      </p>
    </section>
  );
}
